import type { Ad } from "@1sky/shared";

const words = new Intl.Segmenter(undefined, { granularity: "word" });

/** Each matched keyword adds 50 % to an ad's value; ties go to the higher CPM. */
const BOOST_PER_KEYWORD = 0.5;

/**
 * Picks the best ad for this viewer. Runs entirely on-device: transcript text never leaves
 * the browser for ad purposes. Keywords match whole words, or substrings for scripts
 * without spaces (Japanese, Chinese, Thai).
 */
export function scoreAds(ads: Ad[], ctx: { lang: string; recentText: string[] }): Ad | null {
  const text = ctx.recentText.join(" \n ").toLowerCase();
  const tokens = new Set<string>();
  for (const s of words.segment(text)) if (s.isWordLike) tokens.add(s.segment);

  let best: Ad | null = null;
  let bestScore = -1;
  for (const ad of ads) {
    if (ad.languages.length && !ad.languages.includes(ctx.lang)) continue;
    let overlap = 0;
    for (const k of ad.keywords) {
      const kw = k.toLowerCase();
      if (tokens.has(kw) || (!/\s/.test(kw) && /[^\x00-\x7F]/.test(kw) && text.includes(kw))) overlap++;
    }
    const score = ad.cpmCents * ad.weight * (1 + BOOST_PER_KEYWORD * overlap);
    if (score > bestScore || (score === bestScore && best && ad.cpmCents > best.cpmCents)) {
      best = ad;
      bestScore = score;
    }
  }
  return best;
}
